module.exports = __webpack_public_path__ + "img/truck-blue.fd2412bc.svg";